<ng-template>
	<div
		(@transformPopover.done)="_onAnimationDone($event)"
		[@transformPopover]="{ value: state, params: params }"
		[ngClass]="_classList"
		#focusTrapElement
		class="sat-popover-container"
	>
		<mat-card
			[cdkTrapFocusAutoCapture]="true"
			[formGroup]="group"
			cdkTrapFocus
			class="mat-elevation-z6 flex flex-col"
		>
			<div fxHide></div>
			<div class="flex flex-col">
				<div class="flex items-center space-x-2">
					<ng-container *ngIf="mode === 'range_optional'">
						<button
							(click)="stateVisibleMode = !stateVisibleMode"
							[matTooltip]="'timer.time.changeInputMode' | translate"
							[matTooltipOptions]="{ hideOnClick: false }"
							mat-icon-button
							type="button"
						>
							<mat-icon>swap_horiz</mat-icon>
						</button>
					</ng-container>
					<ng-container
						*ngTemplateOutlet="mode === 'range' ? rangeModeTemplate : mode === 'range_optional' ? (stateVisibleMode ? rangeModeTemplate : durationModeTemplate) : mode === 'duration' ? durationModeTemplate : null"
					></ng-container>
				</div>
				<mat-calendar
					(selectedChange)="updateDate($event)"
					[dateFilter]="availableDates"
					[selected]="group.value.date"
					[startAt]="group.value.date"
					class="-mx-16px"
					color="primary"
				></mat-calendar>
				<div
					*ngIf="returnOnSubmit"
					class="-mx-16px -mb-2 flex flex-row items-center justify-end space-x-2 px-2"
				>
					<button
						(click)="close(null)"
						mat-button
					>
						{{ 'utils.cancel' | translate }}
					</button>
					<button
						(click)="close({ value: group.value, entity: item })"
						[disabled]="group.invalid"
						color="primary"
						mat-raised-button
					>
						{{ 'utils.save' | translate }}
					</button>
				</div>
			</div>
			<ng-template #rangeModeTemplate>
				<div class="mat-bd-5 -mb-2 -mt-2 flex flex-1 items-center space-x-4 overflow-hidden rounded-lg">
					<div
						class="grid grid-cols-[70px_auto_70px] flex-shrink-0 flex-grow items-center justify-between gap-x-2"
					>
						<app-time-input
							(click)="this.selectInput($event, startInpRef)"
							(focus)="this.selectInput($event, startInpRef)"
							[displayFormat]="false"
							#startInp
							#startInpRef="nativeElement"
							elementRef
							formControlName="start"
							placeholder="00:00"
						>
							<ng-template
								let-control="control"
								let-inputPlaceholder="inputPlaceholder"
								let-name="name"
								timeInputControl
							>
								<mat-form-field
									appearance="fill"
									class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
								>
									<input
										[attr.cdkFocusInitial]="!focusFieldName || focusFieldName === name ? true : null"
										[formControl]="control"
										[matTooltip]="inputPlaceholder | translate"
										matInput
										type="text"
									>
								</mat-form-field>
							</ng-template>
						</app-time-input>
						<mat-icon inline>arrow_forward</mat-icon>
						<app-time-input
							(click)="this.selectInput($event, endInpRef)"
							(focus)="this.selectInput($event, endInpRef)"
							[displayFormat]="false"
							#endInp
							#endInpRef="nativeElement"
							elementRef
							formControlName="end"
							placeholder="00:00"
						>
							<ng-template
								let-control="control"
								let-inputPlaceholder="inputPlaceholder"
								let-name="name"
								timeInputControl
							>
								<mat-form-field
									appearance="fill"
									class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
								>
									<input
										[attr.cdkFocusInitial]="focusFieldName === name ? true : null"
										[formControl]="control"
										[matTooltip]="inputPlaceholder | translate"
										matInput
										type="text"
									>
								</mat-form-field>
							</ng-template>
						</app-time-input>
					</div>
				</div>
			</ng-template>
			<ng-template #rangeOptModeTemplate>
				<div class="flex flex-col space-y-6">
					<ng-container *ngTemplateOutlet="durationModeTemplate"></ng-container>
					<mat-expansion-panel
						class="!-mx-16px !rounded-none !shadow-none"
						displayMode="flat"
					>
						<mat-expansion-panel-header>Set Start/End</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<div
								class="grid grid-cols-[70px_auto_70px] flex-shrink-0 flex-grow items-center justify-between gap-x-2"
							>
								<app-time-input
									(click)="this.selectInput($event, startInpRef)"
									(focus)="this.selectInput($event, startInpRef)"
									[displayFormat]="false"
									#startInp
									#startInpRef="nativeElement"
									elementRef
									formControlName="start"
									placeholder="00:00"
								>
									<ng-template
										let-control="control"
										let-inputPlaceholder="inputPlaceholder"
										let-name="name"
										timeInputControl
									>
										<mat-form-field
											appearance="fill"
											class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
										>
											<input
												[attr.cdkFocusInitial]="!focusFieldName || focusFieldName === name ? true : null"
												[formControl]="control"
												[matTooltip]="inputPlaceholder | translate"
												matInput
												type="text"
											>
										</mat-form-field>
									</ng-template>
								</app-time-input>
								<mat-icon inline>arrow_forward</mat-icon>
								<app-time-input
									(click)="this.selectInput($event, endInpRef)"
									(focus)="this.selectInput($event, endInpRef)"
									[displayFormat]="false"
									#endInp
									#endInpRef="nativeElement"
									elementRef
									formControlName="end"
									placeholder="00:00"
								>
									<ng-template
										let-control="control"
										let-inputPlaceholder="inputPlaceholder"
										let-name="name"
										timeInputControl
									>
										<mat-form-field
											appearance="fill"
											class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
										>
											<input
												[attr.cdkFocusInitial]="focusFieldName === name ? true : null"
												[formControl]="control"
												[matTooltip]="inputPlaceholder | translate"
												matInput
												type="text"
											>
										</mat-form-field>
									</ng-template>
								</app-time-input>
							</div>
						</ng-template>
					</mat-expansion-panel>
				</div>
			</ng-template>
			<ng-template #durationModeTemplate>
				<tg-duration-input-control
					(click)="this.selectInput($event, durInp)"
					(focus)="this.selectInput($event, durInp)"
					#durInp
					#durInpRef="nativeElement"
					class="flex flex-auto -mb-2"
					displayFormat="HH:mm"
					elementRef
					formControlName="duration"
				>
					<ng-template
						durationInputControl
						let-control="control"
						let-inputPlaceholder="inputPlaceholder"
						let-name="name"
					>
						<mat-form-field
							appearance="fill"
							class="mat-form-field-no-hint cursor-pointer focus-within:cursor-text flex-auto"
						>
							<mat-label translate>timer.time.duration</mat-label>
							<input
								[attr.cdkFocusInitial]="focusFieldName === name ? true : null"
								[formControl]="control"
								matInput
								type="text"
							>
						</mat-form-field>
					</ng-template>
				</tg-duration-input-control>
			</ng-template>
		</mat-card>
	</div>
</ng-template>
